// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	BackButton: 'back-button',
	SendButton: 'send-button',
	DialCode: 'dial-code',
	PhoneNumber: 'phone-number',
	Email: 'email',
	RequiresSecondaryIdInputWrapper: 'requires-secondary-id-input-wrapper',
	RequiresFinancialInstitutionLoginInputWrapper:
		'requires-financial-institution-login-input-wrapper',
	RequiresAdvancedAmlScreeningInputWrapper:
		'requires-advanced-aml-screening-input-wrapper',
	ProfileControlsNameValueNameBadge: 'profile-controls-name-value-name-badge',
	SecondaryIdRequiredSwitch: 'secondary-id-required-switch',
	FinancialInstitutionLoginRequiredSwitch:
		'financial-institution-login-required-switch',
	AdvancedAmlscreeningRequiredSwitch: 'advanced-amlscreening-required-switch',
	IdentityVerificationSettingsButton: 'identity-verification-settings-button',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
